module.exports = __webpack_public_path__ + "static/assets/3eb1599270a7125b2240e7ddc0d5bda1.png";